var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ListItem as RMWCListItem, ListItemText, ListItemPrimaryText, ListItemSecondaryText } from '@rmwc/list';
import classNames from 'classnames';
import IconWrapper from '../IconWrapper';
import withCustomLink from '../../hocs/withCustomLink';
var isMetaIcon = function (meta) {
    return typeof meta.icon !== 'undefined';
};
/** A graphic / icon for the ListItem */
export var ListItemGraphic = function (props) { return (React.createElement(IconWrapper, __assign({}, props.icon, { className: classNames(props.className, 'mdc-list-item__graphic') }))); };
/** Meta content for the ListItem. This can either by an icon by setting the `icon` prop, or any other kind of content. */
export var ListItemMeta = function (props) {
    if (!!props.icon) {
        return (React.createElement(IconWrapper, __assign({}, props.icon, { className: classNames(props.className, 'mdc-list-item__meta') })));
    }
    if (React.isValidElement(props.children)) {
        var children = props.children, rest = __rest(props, ["children"]);
        return React.cloneElement(props.children, __assign(__assign(__assign({}, rest), props.children.props), { className: classNames(props.className, props.children.props.className) }));
    }
    return (React.createElement("div", __assign({}, props, { className: classNames(props.className, 'mdc-list-item__meta') })));
};
/** A simple list item template. */
export var SimpleListItem = function (_a) {
    var text = _a.text, secondaryText = _a.secondaryText, graphic = _a.graphic, metaIcon = _a.metaIcon, meta = _a.meta, children = _a.children, rest = __rest(_a, ["text", "secondaryText", "graphic", "metaIcon", "meta", "children"]);
    var primaryTextToRender = text && secondaryText !== undefined ? (React.createElement(ListItemPrimaryText, null, text)) : (text);
    var secondaryTextToRender = secondaryText !== undefined ? (React.createElement(ListItemSecondaryText, null, secondaryText)) : null;
    return (React.createElement(RMWCListItem, __assign({}, rest),
        graphic !== undefined && React.createElement(ListItemGraphic, { icon: graphic }),
        secondaryTextToRender !== null ? (React.createElement(ListItemText, null,
            primaryTextToRender,
            secondaryTextToRender)) : (primaryTextToRender),
        (!!meta || !!metaIcon) && (React.createElement(ListItemMeta, { icon: metaIcon }, meta)),
        children));
};
SimpleListItem.displayName = 'SimpleListItem';
/**
 * List Item component
 *
 * @see **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/v0.2.1/content/components/list.md
 *
 */
var ListItem = function ListItem(_a) {
    var item = _a.item, _b = _a.mode, mode = _b === void 0 ? 'default' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, tabIndex = _a.tabIndex, LinkTag = _a.linkTag, props = __rest(_a, ["item", "mode", "className", "tabIndex", "linkTag"]);
    var getMeta = function (listItem) {
        var meta = listItem.meta;
        if (meta && meta.icon && meta.text) {
            throw new Error("You can't define both meta icon and text");
        }
        return meta;
    };
    var renderContent = function (item) {
        if (typeof item === 'string') {
            return item;
        }
        else if (mode === 'fully-featured') {
            var meta = getMeta(item);
            return (React.createElement(React.Fragment, null,
                item.icon && React.createElement(ListItemGraphic, { icon: item.icon }),
                React.createElement(ListItemText, null,
                    React.createElement(ListItemPrimaryText, null, item.text),
                    React.createElement(ListItemSecondaryText, null, item.secondaryText)),
                meta &&
                    (isMetaIcon(meta) ? (React.createElement(ListItemMeta, { icon: meta.icon })) : (React.createElement(ListItemMeta, null, meta.text)))));
        }
        else {
            return item.text;
        }
    };
    if (mode === 'simple') {
        if (item.to) {
            throw new Error("You can't use links in simple mode");
        }
        var meta = getMeta(item);
        return (React.createElement(SimpleListItem, { tag: "li", graphic: item.icon, text: item.text, secondaryText: item.secondaryText, metaIcon: meta && isMetaIcon(meta) ? meta.icon : undefined, meta: meta && !isMetaIcon(meta) && meta.text, activated: item.activated }));
    }
    else {
        var hasTabIndex = typeof tabIndex !== 'undefined';
        var contents = renderContent(item);
        // Handle links.
        if (item.to) {
            // Handle custom Link tags, like React Router.
            contents = (React.createElement(LinkTag, { to: item.to, target: item.target || '_blank', tabIndex: hasTabIndex ? tabIndex : 0 }, contents));
        }
        return (React.createElement(RMWCListItem, __assign({ className: "madonna-list-item " + className, tag: "li", activated: item.activated, tabIndex: item.to ? -1 : hasTabIndex ? tabIndex : 0 }, props), contents));
    }
};
export default withCustomLink(function (_a) {
    var customLinkTag = _a.customLinkTag, props = __rest(_a, ["customLinkTag"]);
    return (React.createElement(ListItem, __assign({ linkTag: customLinkTag }, props)));
});
//# sourceMappingURL=ListItem.js.map